import { LightInfoApiModel } from '@rocksoft/inroom-sdk';

import { Action } from '@ngrx/store';

export enum LightsActionTypes {
  LOAD_LIGHTS = '[Light] Load Lights',
  NO_LIGHTS = '[Light] No Lights',
  UPDATE_LIGHTS = '[Light] Update Light',
  LIGHT_SUCCESS = '[Light] Light Success',
}

export interface LightLocationModel extends LightInfoApiModel {
  HotelCode?: string;
  Room?: string;
}

export class LoadLights implements Action {
  readonly type = LightsActionTypes.LOAD_LIGHTS;

  constructor(public payload: LightInfoApiModel[]) {}
}

export class NoLight implements Action {
  readonly type = LightsActionTypes.NO_LIGHTS;
}

export class LightSuccess implements Action {
  readonly type = LightsActionTypes.LIGHT_SUCCESS;

  constructor(public payload: LightInfoApiModel) {}
}

export class UpdateLight implements Action {
  readonly type = LightsActionTypes.UPDATE_LIGHTS;

  constructor(public payload: { id: string; changes: LightLocationModel }) {}
}

export type LightsActionsUnion = LoadLights | NoLight | LightSuccess | UpdateLight;
